import Head from "next/head";

import { useLabel } from "../../../hooks/useLabel";

/**
 * Favicons Generated w/ https://realfavicongenerator.net/
 */
export const HeadLabel = () => {
  const { label } = useLabel();
  const assetDir = `/icons/${label.name}`;

  return (
    <Head>
      <meta
        name="viewport"
        content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover"
      />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta
        name="apple-mobile-web-app-status-bar-style"
        content="black-translucent"
      />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="shortcut icon" href={`${assetDir}/favicon.ico`} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${assetDir}/apple-touch-icon.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${assetDir}/favicon-32x32.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${assetDir}/favicon-16x16.png`}
      />
      <link rel="manifest" href="/api/manifest.json" />
    </Head>
  );
};
